import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

// `pages` / `range` override the even-split math for lists with uneven pages.
export function Pagination({ page, pageSize, total, onPage, testId = "pagination", pages: forcedPages, range }) {
  const pages = forcedPages || Math.max(1, Math.ceil(total / pageSize));
  const [from, to] = range || [(page - 1) * pageSize + 1, Math.min(page * pageSize, total)];
  if (!total) return null;
  return (
    <div className="mt-4 flex items-center justify-between" data-testid={testId}>
      <p className="text-sm text-slate-500">
        Showing {from}–{to} of {total}
      </p>
      {pages > 1 && (
        <div className="flex items-center gap-3">
          <Button variant="outline" size="sm" className="rounded-full" disabled={page <= 1}
            onClick={() => onPage(page - 1)} data-testid={`${testId}-prev`}>
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <span className="text-sm font-medium text-slate-600 tabular-nums" data-testid={`${testId}-page`}>{page} / {pages}</span>
          <Button variant="outline" size="sm" className="rounded-full" disabled={page >= pages}
            onClick={() => onPage(page + 1)} data-testid={`${testId}-next`}>
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      )}
    </div>
  );
}

export default Pagination;
